
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.book-guide-page__details {
  padding: 40px 30px;
  max-width: $container-max-width;
  display: grid;
  grid-template-columns: auto;
  margin: auto;

  h2 {
    font-size: 26px;
    font-weight: normal;
    line-height: 37px;
    margin-bottom: 25px;
  }

  ul {
    list-style: disc;
    margin-left: 20px;
    margin-bottom: 50px;

    li {
      background: none;
      list-style: disc;

      &::before {
        display: none;
      }
    }
  }

  .rich-text {
    li {
      padding-left: 0;
    }
  }
}

@include media-query(desktop) {
  .book-guide-page__details {
    grid-template-columns: 1fr 1fr;
  }
}
`